export default __webpack_public_path__ + "static/media/09n.891e41ec.svg";